const list = {
    path: 'equipmentManagement',
    component: resolve => require(['@/pages/admin/aftersales/equipmentManagement'], resolve)
}

export default list
